import React from "react";
import { Link } from "react-router-dom";

interface GridViewProps<T> {
    data: T[];
    renderCard: (item: T, index: number) => React.ReactNode;
    columns?: any; // Optional, can be used for responsive grid setup if needed
    className?: string; // Optional custom class for the grid container
}

const GridView = <T,>({ data, renderCard, className }: GridViewProps<T>) => {
    return (
        <div className={`row ${className || ""}`}>
            {data.map((item, index) => (
                <React.Fragment key={index}>
                    {renderCard(item, index)}
                </React.Fragment>
            ))}
            {data.length === 0 && (
                <div className="col-12 text-center p-5">
                    <div className="text-muted">No data available</div>
                </div>
            )}
        </div>
    );
};

export default GridView;
